// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid.users {
  grid-template-columns: repeat(7, auto);
  padding: 20px 10px;
}
.grid.users .a {
  background-color: #e0eeed;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/users-list/users-list.component.less"],"names":[],"mappings":"AAAA;EACI,sCAAA;EACA,kBAAA;AACJ;AAHA;EAKM,yBAAA;AACN","sourcesContent":[".grid.users {\n    grid-template-columns: repeat(7, auto);\n    padding: 20px 10px;\n\n    .a {\n      background-color: #e0eeed;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
